import { raise, setup } from 'xstate5';

import {
  resetInteractedStore,
  setInteractedStore,
  setLastInteractedStore,
} from './LastInteractedStore.machine.actions';

import type {
  LastInteractedStoresContext,
  LastInteractedStoresEvent,
} from './LastInteractedStore.machine.types';

// ─── MACHINE ────────────────────────────────────────────────────────────────────

/**
 * Stores last interacted store information (delivery address ID or store/restaurant slug)
 * based on the listed sources in the following order:
 *
 * 1. Active cart.
 * 2. Last interacted menu.
 * 3. Last placed order.
 *
 * If the top source isn't available, the one below it
 * will be used as a fallback (all the way down to "undefined").
 */
export const LastInteractedStoreMachine = setup({
  types: {
    context: {} as LastInteractedStoresContext,
    events: {} as LastInteractedStoresEvent,
  },
  actions: {
    setLastInteractedStore,
    setInteractedStore,
    resetInteractedStore,
  },
}).createMachine({
  context: {
    interactedStores: {
      menu: undefined,
      activeCart: undefined,
      lastPlacedOrder: undefined,
    },
    lastInteractedStore: undefined,
  },
  on: {
    //
    // ─────────────────────────────────────────────────────────────────

    SET_LAST_INTERACTED_MENU_STORE: {
      actions: [
        { type: 'setInteractedStore', params: { storeKind: 'menu' } },
        raise({ type: 'SET_LAST_INTERACTED_STORE' }),
      ],
    },
    SET_ACTIVE_CART_STORE: {
      actions: [
        { type: 'setInteractedStore', params: { storeKind: 'activeCart' } },
        raise({ type: 'SET_LAST_INTERACTED_STORE' }),
      ],
    },
    SET_LAST_PLACED_ORDER_STORE: {
      actions: [
        { type: 'setInteractedStore', params: { storeKind: 'lastPlacedOrder' } },
        raise({ type: 'SET_LAST_INTERACTED_STORE' }),
      ],
    },

    // ─────────────────────────────────────────────────────────────────

    SET_LAST_INTERACTED_STORE: {
      actions: 'setLastInteractedStore',
    },

    // ─────────────────────────────────────────────────────────────────

    RESET_LAST_INTERACTED_MENU_STORE: {
      actions: [
        { type: 'resetInteractedStore', params: { storeKind: 'menu' } },
        raise({ type: 'SET_LAST_INTERACTED_STORE' }),
      ],
    },
    RESET_ACTIVE_CART_STORE: {
      actions: [
        { type: 'resetInteractedStore', params: { storeKind: 'activeCart' } },
        raise({ type: 'SET_LAST_INTERACTED_STORE' }),
      ],
    },
    RESET_LAST_PLACED_ORDER_STORE: {
      actions: [
        { type: 'resetInteractedStore', params: { storeKind: 'lastPlacedOrder' } },
        raise({ type: 'SET_LAST_INTERACTED_STORE' }),
      ],
    },
  },
});
